/* Sintonizadores de TV de la red de casa (TDT, cable, satélite): se añaden como una lista M3U normal.
 *  - HDHomeRun (SiliconDust): no publica una lista M3U fiable, sino su «lineup» en JSON (http://IP/lineup.json); aquí se convierte en M3U.
 *    Los canales se ven por la dirección de cada uno (http://IP:5004/auto/v2.1, MPEG-TS); cada canal abierto ocupa un sintonizador.
 *  - TVHeadend: ya publica la lista (http://IP:9981/playlist/channels.m3u) y la guía (http://IP:9981/xmltv/channels).
 * Basta con escribir la dirección del aparato (192.168.1.50 o http://192.168.1.50:9981) en el campo de la lista M3U. */

const BARE = /^(?:https?:\/\/)?((?:\d{1,3}\.){3}\d{1,3}|[a-z0-9][a-z0-9.-]*\.(?:local|lan|home)|hdhomerun[a-z0-9.-]*|tvheadend[a-z0-9.-]*)(:\d+)?\/?$/i;

/** De lo que escribe la persona a la lista que se descarga: { url, epgUrl } o null si no parece la dirección de un sintonizador (se deja como está). */
export function tunerSource(input) {
    const raw = String(input || '').trim();
    const m = BARE.exec(raw);
    if (m) {
        const origin = (/^https?:\/\//i.test(raw) ? raw.replace(/^(https?:\/\/).*$/i, '$1').toLowerCase() : 'http://') + m[1] + (m[2] || '');
        // 9981 (y 9982) es el puerto de TVHeadend; sin puerto o con el 80, un HDHomeRun.
        if (m[2] && /^:998[12]$/.test(m[2])) return { url: origin + '/playlist/channels.m3u', epgUrl: origin + '/xmltv/channels', kind: 'tvheadend' };
        return { url: origin + '/lineup.json', epgUrl: '', kind: 'hdhomerun' };
    }
    // La lista de TVHeadend pegada tal cual: la guía está en el mismo sitio.
    const t = /^(https?:\/\/[^/]+)\/playlist\/channels(?:\.m3u)?(?:\?.*)?$/i.exec(raw);
    if (t) return { url: raw, epgUrl: t[1] + '/xmltv/channels', kind: 'tvheadend' };
    return null;
}

const attr = (s) => String(s == null ? '' : s).replace(/["\r\n]/g, '').trim();

/** ¿Es el «lineup» de un HDHomeRun? (una lista JSON de canales con GuideNumber). */
export function isHdhrLineup(text) {
    const s = String(text || '').trimStart();
    if (s[0] !== '[') return false;
    try { const j = JSON.parse(s); return Array.isArray(j) && j.length > 0 && j.every((x) => x && typeof x === 'object') && j.some((x) => x.GuideNumber != null || x.GuideName != null); } catch (e) { return false; }
}

/** El «lineup» de un HDHomeRun → texto M3U. Se saltan los canales con protección (DRM) y los que no traen dirección. `base` es la dirección de la que vino. */
export function hdhrLineupToM3u(text, base = '') {
    const j = JSON.parse(String(text).trim());
    let origin = '';
    try { origin = new URL(base).hostname; } catch (e) { origin = ''; }
    const out = ['#EXTM3U'];
    j.forEach((c) => {
        if (!c || c.DRM === 1 || c.DRM === true) return;
        const num = attr(c.GuideNumber);
        const url = String(c.URL || '').trim() || (origin && num ? 'http://' + origin + ':5004/auto/v' + num : '');
        if (!url) return;
        const name = attr(c.GuideName) || num;
        out.push('#EXTINF:-1 tvg-id="' + num + '" tvg-chno="' + num + '" tvg-name="' + name + '" group-title="TDT"' + ',' + name);
        out.push(url);
    });
    return out.join('\n') + '\n';
}

/** Lo descargado como lista de canales: M3U tal cual, o el lineup de un HDHomeRun convertido. */
export function m3uTextFrom(text, base = '') {
    return isHdhrLineup(text) ? hdhrLineupToM3u(text, base) : text;
}
